import { IconProps } from "./Icon.model";

export function Internet({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33789 9.89164C1.24347 10.3759 1.19626 10.6181 1.34722 10.8016C1.49818 10.9852 1.76037 10.9852 2.28475 10.9852H5.99473C6.4489 10.9852 6.67599 10.9852 6.82072 10.8508C6.96545 10.7164 6.98312 10.4831 7.01844 10.0166C7.17915 7.89382 7.5946 5.96801 8.20067 4.44646C8.58093 3.4918 9.08165 2.54041 9.82321 1.81486C10.14 1.50495 10.2983 1.34999 10.2621 1.28307C10.2258 1.21614 10.0244 1.2613 9.62167 1.35162C5.43808 2.28982 2.16472 5.65075 1.33789 9.89164Z"
        fill={fillColor}
      />
      <path
        d="M2.28479 13.015C1.76039 13.015 1.4982 13.015 1.34724 13.1986C1.19628 13.3821 1.2435 13.6243 1.33793 14.1086C2.1648 18.3494 5.43809 21.7102 9.62158 22.6484C10.0242 22.7387 10.2256 22.7838 10.2618 22.7169C10.2981 22.65 10.1398 22.4951 9.82312 22.1853C9.0816 21.4597 8.58091 20.5084 8.20067 19.5538C7.5946 18.0322 7.17915 16.1064 7.01844 13.9837C6.98312 13.5171 6.96545 13.2838 6.82072 13.1494C6.67599 13.015 6.4489 13.015 5.99473 13.015H2.28479Z"
        fill={fillColor}
      />
      <path
        d="M14.171 22.1865C13.8543 22.4961 13.6959 22.651 13.7322 22.7179C13.7684 22.7848 13.9697 22.7398 14.3723 22.6498C18.5587 21.7135 21.8348 18.3514 22.6621 14.1086C22.7565 13.6243 22.8037 13.3821 22.6528 13.1986C22.5018 13.015 22.2396 13.015 21.7152 13.015H18.0007C17.5465 13.015 17.3194 13.015 17.1747 13.1494C17.0299 13.2838 17.0123 13.5171 16.9769 13.9837C16.8162 16.1064 16.4008 18.0322 15.7947 19.5538C15.4143 20.5089 14.9132 21.4608 14.171 22.1865Z"
        fill={fillColor}
      />
      <path
        d="M21.7152 10.9852C22.2396 10.9852 22.5018 10.9852 22.6528 10.8016C22.8037 10.6181 22.7565 10.3759 22.6621 9.89164C21.8349 5.6487 18.5587 2.28656 14.3722 1.35026C13.9695 1.26019 13.7681 1.21516 13.7319 1.28209C13.6957 1.34903 13.8541 1.5039 14.1709 1.81363C14.9132 2.5393 15.4143 3.49129 15.7947 4.44646C16.4008 5.96801 16.8162 7.89382 16.9769 10.0166C17.0123 10.4831 17.0299 10.7164 17.1747 10.8508C17.3194 10.9852 17.5465 10.9852 18.0007 10.9852H21.7152Z"
        fill={fillColor}
      />
      <path
        d="M13.9365 5.30032C14.4362 6.52593 14.8079 8.13294 14.9692 9.95969C15.0113 10.437 15.0324 10.6757 14.8819 10.8378C14.7315 11 14.4815 11 13.9815 11H10.0185C9.51853 11 9.26852 11 9.11807 10.8378C8.96763 10.6757 8.9887 10.437 9.03085 9.95969C9.19214 8.13294 9.56382 6.52593 10.0635 5.30032C10.404 4.46523 10.7839 3.85653 11.1536 3.47296C11.5213 3.0915 11.8077 3 12 3C12.1923 3 12.4787 3.0915 12.8464 3.47296C13.2161 3.85653 13.596 4.46523 13.9365 5.30032Z"
        fill={fillColor}
      />
      <path
        d="M10.0635 18.6997C9.56382 17.4741 9.19214 15.8671 9.03085 14.0403C8.9887 13.563 8.96763 13.3243 9.11807 13.1622C9.26852 13 9.51853 13 10.0185 13H13.9815C14.4815 13 14.7315 13 14.8819 13.1622C15.0324 13.3243 15.0113 13.563 14.9692 14.0403C14.8079 15.8671 14.4362 17.4741 13.9365 18.6997C13.596 19.5348 13.2161 20.1435 12.8464 20.527C12.4787 20.9085 12.1923 21 12 21C11.8077 21 11.5213 20.9085 11.1536 20.527C10.7839 20.1435 10.404 19.5348 10.0635 18.6997Z"
        fill={fillColor}
      />
    </svg>
  );
}
